import Banner from "~/components/banner"
import MarkdownArticle from "~/components/markdownArticle"
import { readFileSync } from "fs"

const article = readFileSync(__dirname + "/article.md", "utf-8")

export default class EvaluateClaims extends Component {
  render() {
    return (
      <React.Fragment>
        <Banner
          noFigure
          title="How should we evaluate claims about features?"
        />
        <MarkdownArticle src={article} />
      </React.Fragment>
    )
  }
}
